var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.computedDivClass},[_c('v-row',[_c('v-col',{attrs:{"cols":_vm.col,"offset":_vm.offset}},[_vm._t("default",function(){return [_vm._v("No content")]})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }